import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-detran-pr',
  templateUrl: './consulta-detran-pr.component.html',
  styleUrls: ['./consulta-detran-pr.component.scss']
})
export class ConsultaDetranPrComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  texto = null;

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.loadTxtDetran();
  }

  loadTxtDetran(){
    if( this.consulta.listaDadosCertificadoSeguranca==null || this.consulta.listaDadosCertificadoSeguranca.length==0){
      this.texto = "Nenhum certificados de segurança encontrado.";
      this.status = 'info';
    }else{
      this.status = 'danger';
    }
  }

}
